/* eslint-disable */

import { VueEditor } from "vue2-editor";
import { mapGetters } from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'public-add-quiz',
  components: {
    VueEditor
  },
  props: [],
  data() {
    return {
      quizData: {
        name: '',
        category: '',
        instruction: '',
        quiz_number: '',
        time_limit:90,
      },
      coursesCategory: {},
      submitted:false,
      courseDetais:'',
      pub_catID:'',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      instruction:''
    }
  },
  computed: {
    ...mapGetters([
      'getcourseCategoryState'
    ]),
    getCourseList() {
      return this.coursesCategory = this.$store.getters.getcourseCategoryState.data
    }
  },
  mounted() {
    this.pub_catID = this.$route.params.quiz_catId
  },
  methods: {
    validateCreateQuizBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            name: this.quizData.name,
            instruction: this.quizData.instruction,
            category: this.quizData.category,
            quiz_number:this.quizData.quiz_number,
            time_limit:this.quizData.time_limit
          }
          this.$store.dispatch('createQuizFun', data)
          .then((res) => {
            this.quizData.name = '',
            this.quizData.instruction = '',
            this.quizData.category = '',
            this.quizData.time_limit = '',
            toast.success(res.data.msg);
            this.$validator.reset();
            this.$router.push('/course/public/quizzes/category/' + this.pub_catID + '/list/' )
            })
            .catch((err) => {})
          return
        }
      });
    },
  },
  beforeMount() {
    this.getCourseList;
  },
  watch: {
    getCourseList() {
      return this.$store.getters.getcourseCategoryState.data
    }
  }
}